export default {"src":"/_next/static/media/img-vibe-at-devkrest-7.8a616ecd.webp","height":500,"width":282,"blurWidth":0,"blurHeight":0};